import { ENDPOINT_IFP_APPLICATION_ACTION, IfpApplicationAction, IfpApplicationActionResponse } from '@shared/sec-loans'
import { isErrorResponse } from '@ui-common/utils'
import { callEndpoint } from '@ui-common/utils/http'
import { AnyActorRef, ErrorActorEvent, fromPromise, sendTo, setup } from 'xstate'

export const ERROR = 'error'
export const SENDING = 'sending'

export interface SendStepApplicationData {
  applicationId: string
  actionType: IfpApplicationAction
  authCode: string
}

export const sendStepMachine = (parentService: AnyActorRef) => {
  return setup({
    types: {
      context: {} as SendStepApplicationData,
      input: {} as SendStepApplicationData,
    },
    actions: {
      sendSuccess: sendTo(parentService, (_: unknown, data: IfpApplicationActionResponse) => ({
        type: 'SEND_SUCCESS',
        data,
      })),
      sendFailed: sendTo(parentService, (_: unknown, error: unknown) => {
        return { type: 'SEND_FAILED', error: isErrorResponse(error) ? error : undefined }
      }),
    },
    actors: {
      submitIfpApplication: fromPromise(({ input }: { input: SendStepApplicationData }) => {
        return callEndpoint(ENDPOINT_IFP_APPLICATION_ACTION, {
          pathParams: { applicationId: input.applicationId, action: input.actionType },
          requestPayload: {
            authCode: input.authCode,
          },
          requestConfig: {
            maxRetries: 1,
          },
        })
      }),
    },
  }).createMachine({
    initial: SENDING,
    context: ({ input }) => input,
    states: {
      [SENDING]: {
        invoke: {
          id: 'submitIfpApplication',
          src: 'submitIfpApplication',
          input: ({ context }) => context,
          onDone: {
            actions: {
              type: 'sendSuccess',
              params: ({ event }) => event.output,
            },
          },
          // TODO: DIG-6575 Improve error handling
          onError: {
            actions: [{ type: 'sendFailed', params: ({ event }: { event: ErrorActorEvent }) => event.error }],
          },
        },
      },
    },
  })
}
